import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addBet, removeBet } from "../../../store/betslip-slice";
import { toastService } from "../../notificationPage/ToastContainer";

const MatchRow = ({ match, getOddsGroup }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bets = useSelector((state) => state.betSlip.bets);

  // Find any existing bet for this match
  const existingBet = bets.find((bet) => bet.match.id === match.gameId);

  const handleMatchClick = () => {
    // Navigate to match profile using match ID
    navigate(`/match/${match.gameId}`);
  };
  // console.log("🔍 MatchRow Rendered - gameId:", match.gameId);
  // console.log("🔍 Full match object:", match);
  // console.log("🆔 Extracted gameId:", match.gameId);

  // Handle odd selection with single bet per match restriction
  const handleOddSelect = (odd) => {
    const matchData = {
      id: match.gameId,
      name: `${match.team1} V ${match.team2}`,
      date: match.eventDate,
      market: odd.market || "Match Result",
    };

    const market = {
      marketName: odd.market || "Match Result",
    };

    // Check if this exact odd is already selected
    // const isExactOddSelected =
    //   existingBet &&
    //   existingBet.odd.label === odd.label &&
    //   existingBet.market.marketName === (odd.market || "Match Result");
    console.log("✅ Clicked match ID:", match.gameId);
    const betExists = isOddSelected(odd, match.gameId);
    // Check if any bet exists for this match
    const hasAnyBetForMatch = bets.some((bet) => bet.match.id === match.gameId);
    console.log("mid", match.gameId, hasAnyBetForMatch);

    if (betExists) {
      // Remove the bet if it's already selected
      dispatch(removeBet({ match: matchData, odd, market }));
      toastService.warning(`Removed: ${odd.label}`);
    } else if (hasAnyBetForMatch) {
      console.log("logged here");
      console.log("logged here", existingBet.market);
      // Remove existing bet for this match before adding new one
      dispatch(
        removeBet({
          match: existingBet.match,
          odd: existingBet.odd,
          market: existingBet.market,
        })
      );

      // Add the new bet
      dispatch(addBet({ match: matchData, odd, market }));
      toastService.info(`Changed selection to: ${odd.label}`);
    } else {
      // Add new bet when no bet exists for this match
      dispatch(addBet({ match: matchData, odd, market }));
      toastService.success(`Added: ${odd.label} @ ${odd.value}`);
    }
  };
  const isOddSelected = useCallback(
    (odd, gameId) => {
      console.log("✅✅✅😤", odd);
      // if (!data || !data.events || !data.events[0]) return false;
      // if (!existingBet) return false;

      return bets.some((bet) => {
        console.log("test", bet.match.id, gameId);
        return (
          bet.match.id === match.gameId &&
          bet.odd.label === odd.label &&
          bet.market?.marketName === odd.market
        );
      });
    },
    [bets, match?.gameId]
  );

  // Check if an odd is selected
  // const isOddSelected = (odd) => {
  //   if (!existingBet) return false;

  //   return (
  //     existingBet.odd.label === odd.label &&
  //     existingBet.market.marketName === (odd.market || "Match Result")
  //   );
  // };

  return (
    <div className="flex justify-between items-center max-sm:p-[12px_15px] py-2 s16:py-3 px-5 s18:p-[15px_23px]">
      {/* Teams - Fixed width container */}
      <div
        onClick={handleMatchClick}
        className="cursor-pointer w-[200px] max-lg:w-[180px] max-md:w-[150px] max-sm:w-[120px] flex-shrink-0 mr-4"
      >
        <p className="text-white text-xs sm:text-sm s18:text-base font-normal leading-[143%] md:leading-tight s18:leading-[143%]">
          {match.team1}
        </p>
        <p className="text-white text-xs sm:text-sm s18:text-base font-normal leading-[143%] md:leading-tight s18:leading-[143%]">
          {match.team2}
        </p>
        <p className="flex items-center gap-[5px] mt-[5px]">
          {match.details.map((detail, detailIndex) => (
            <span
              key={detailIndex}
              className={`max-sm:text-[9px] text-xs leading-[133%] ${
                detail.bold ? "font-bold" : "font-normal"
              } ${detail.colorRed ? "text-[#F87171]" : "text-extralightwhite"}`}
            >
              {detail.text}
            </span>
          ))}
        </p>
      </div>

      {/* Odds */}
      <div className="scrollable max-sm:w-full max-sm:max-w-[50%] max-lg:overflow-auto w-full lg:max-w-[520px] xl:max-w-[700px] s15:max-w-[550px] s18:max-w-[645px]">
        <div className="w-full max-sm:min-w-full  max-lg:min-w-[550px] lg:max-w-[520px] xl:max-w-[700px] s15:max-w-[550px] s18:max-w-[645px] sm:grid sm:grid-cols-12 gap-3 xl:gap-[18px]">
          {match.odds.map(
            (group, groupIndex) =>
              getOddsGroup(match, groupIndex) && (
                <div key={groupIndex} className="sm:col-span-4">
                  <div className="flex gap-1">
                    {group.map((odd, oddIndex) => {
                      // console.log("odd..", odd);
                      const oddData = {
                        label: odd.label,
                        value: odd.value,
                      };
                      // Add market information to odd if not present
                      const oddWithMarket = {
                        ...odd,
                        market:
                          odd.market ||
                          (groupIndex === 0
                            ? "Match Result"
                            : groupIndex === 1
                            ? "Double Chance"
                            : "Goals Over/Under"),
                      };

                      const isSelected = isOddSelected(
                        oddWithMarket,
                        match.gameId
                      );

                      return (
                        <div key={oddIndex} className="w-1/2">
                          <div
                            className={`odd-block cursor-pointer rounded-md w-full py-3 md:py-2 s18:py-3  flex flex-col gap-1 border items-center justify-center 
                                                        ${
                                                          isSelected
                                                            ? "bg-[#E2E2E2]  text-black  border-yellow"
                                                            : "bg-teal border-doubleextralightwhite"
                                                        }
                            ${
                              existingBet && !isSelected
                                ? "opacity-75"
                                : "opacity-100"
                            }`}
                            onClick={() => handleOddSelect(oddWithMarket)}
                          >
                            <span
                              className={`${
                                odd.highlight
                                  ? "flex items-center gap-[1px]"
                                  : ""
                              } ${
                                isSelected ? "!text-darkblue" : ""
                              }  text-extralightwhite text-xs font-normal leading-normal md:leading-tight s18:leading-normal`}
                            >
                              {odd.label}
                              {odd.highlight && (
                                <span className="ml-[2px] mb-[1px] w-0 h-0 border-b-[9px] border-b-[#11A306] border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent"></span>
                              )}
                            </span>
                            <span
                              className={`${
                                isSelected ? "!text-darkblue" : ""
                              } text-white text-sm s18:text-base font-medium leading-normal md:leading-tight s18:leading-normal`}
                            >
                              {odd.value}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )
          )}
        </div>
      </div>

      {/* Visual indicator that the match has a selection */}
      {/* {existingBet && (
        <div className="ml-2 px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
          Selected
        </div>
      )} */}
    </div>
  );
};

export default MatchRow;
